import { isPlainObject } from "lodash-es";
const isComponent = (val) => isPlainObject(val);
export {
  isComponent
};
